import MomentUtils from "@date-io/moment";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";
import { localized } from "../../../../state/i18n/i18n";
import { DateFormat } from "../../../../utilities/constants";
import "./date-range-picker.scss";

interface PropsFromParent {
  dateChanged: (DateFrom: Date, DateTo: Date) => void;
  dateFrom: Date;
  dateTo: Date;
}

export class DateRangePicker extends React.PureComponent<PropsFromParent> {
  public render() {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <KeyboardDatePicker
          margin="normal"
          id="from-date-picker-dialog"
          className="datePickerFromDate"
          label={localized("FromDate")}
          format={DateFormat}
          maxDate={this.props.dateTo}
          value={this.props.dateFrom}
          onChange={this.DateFromChanged}
        />
        <span className="alignCenterPaddingTop20">-</span>
        <KeyboardDatePicker
          margin="normal"
          className="datePickerToDate"
          id="to-date-picker-dialog"
          label={localized("ToDate")}
          format={DateFormat}
          value={this.props.dateTo}
          onChange={this.DateToChanged}
        />
      </MuiPickersUtilsProvider>
    );
  }

  // Any type because the type from the lib is wrong
  private DateFromChanged = (d: any) => {
    if (d) {
      this.props.dateChanged(d.toDate(), this.props.dateTo);
    }
  };

  // Any type because the type from the lib is wrong
  private DateToChanged = (d: any) => {
    if (d) {
      this.setState({ dateTo: d.toDate() });
      this.props.dateChanged(this.props.dateFrom, d.toDate());
    }
  };
}
